"use strict";var e=require("./deepMerge.cjs");exports.deepMergeAll=function(r,t){for(var s=r[0],c=0,g=r.slice(1);c<g.length;c++){var i=g[c];s=e.deepMerge(s,i,t)}return s};
//# sourceMappingURL=deepMergeAll.cjs.map
